import { Box, Chip, Stack, Typography } from "@mui/material";
import CheckroomOutlinedIcon from "@mui/icons-material/CheckroomOutlined";

import { ICamiseta } from "interfaces/kitsCamiseta";

import { inscritosSectionSx } from "../lista-inscritos.theme";

type Props = {
  tamCamisetas: ICamiseta[];
  counts: Record<string, number>;
};

export default function TotalCamisetas({ tamCamisetas, counts }: Props) {
  if (!tamCamisetas.length) return null;

  const total = tamCamisetas.reduce(
    (sum, camiseta) => sum + (counts[camiseta.tamanho.toUpperCase()] ?? 0),
    0,
  );

  return (
    <Box sx={{ ...inscritosSectionSx, mb: 2 }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
        spacing={1}
        mb={1.5}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <CheckroomOutlinedIcon fontSize="small" color="action" />
          <Typography variant="subtitle2" fontWeight={700}>
            Camisetas por tamanho
          </Typography>
        </Stack>
        <Typography variant="caption" color="text.secondary">
          Total na lista filtrada: {total}
        </Typography>
      </Stack>

      <Stack direction="row" flexWrap="wrap" gap={1}>
        {tamCamisetas.map((camiseta) => {
          const qtd = counts[camiseta.tamanho.toUpperCase()] ?? 0;
          return (
            <Chip
              key={camiseta.id}
              label={`${camiseta.tamanho}: ${qtd}`}
              variant="outlined"
              size="small"
              sx={{
                fontWeight: 600,
                borderRadius: 1.5,
                bgcolor: qtd > 0 ? "grey.50" : "transparent",
              }}
            />
          );
        })}
      </Stack>
    </Box>
  );
}
